import { Address } from "@/contexts/UserContext";
import { API } from "@/lib/api";
import { CreateAddressBody, CreateAddressResponse } from "@boxem/core-api-schema";

export async function createAddress(address: CreateAddressBody): Promise<CreateAddressResponse> {
  return API.post<CreateAddressResponse>(`/addresses`, address, null);
}

export function getAddresses() {
  return API.get<Address[]>(`/addresses`, null);
}

export function editAddress(address: Address) {
  return API.patch<Address>(`/addresses/${address.id}`, address, null);
}
